import React from 'react'
import { GrEdit } from "react-icons/gr";
import moment from "moment-timezone";

const RGLimits = ({setOpenRGLimit,userObject,rgLimitList}) => {
    return (
        <div className="row">
            <div className="col-md-12">
                <div className="border-only mt-3">
                    <div className="d-flex justify-content-between gap-2">
                        <h6 className="dark-gray f-bold">RG Limits : </h6>
                        <h6 className="darkgray">
                            <span
                                onClick={() => {
                                    setOpenRGLimit(true);
                                }}
                            >
                                <GrEdit />
                            </span>
                        </h6>
                    </div>
                    {
                        userObject?.rg_LimitsDto &&
                        userObject?.rg_LimitsDto.map((item, index) => {
                            let typeName = rgLimitList.filter(
                                (data) => data.id == item.rg_type
                            );
                            return (
                                <>
                                    <div className="d-flex justify-content-between gap-2 s-size">
                                        <p>
                                            <span className="green-color f-bold limit-name">
                                                {typeName[0]?.name} :
                                            </span>{" "}
                                            <span className="darkgray f-bold">Period : </span>{" "}
                                            <span className="darkgray">{item?.time_period} Days</span>
                                        </p>
                                        <p className="darkgray">
                                            <span className="f-bold">Amount : </span>{" "}
                                            <span className="">$ {item?.rg_limit_value}</span>
                                        </p>
                                        <p className="darkgray">
                                            <span className="f-bold">Balance : </span>{" "}
                                            <span>$ {item?.remaining_balance}</span>
                                        </p>
                                        <p className="darkgray">
                                            <span className="f-bold">Reset Date : </span>{" "}
                                            <span>



                                                {

                                                    moment(item?.reset_date).format("MMM Do YYYY")
                                                }
                                            </span>
                                        </p>
                                    </div>

                                </>
                            )
                        })
                    }

                </div>

            </div>
        </div>
    )
}

export default RGLimits